import { Outlet, createFileRoute } from '@tanstack/react-router';
import { guardSection } from '../../shell/guard.ts';

// Safeguards and evidence (plan §9, T26): the register at /evidence and each evidence line at
// /evidence/$code share the gate (evidence.read).
export const Route = createFileRoute('/_authed/evidence')({
  beforeLoad: guardSection('/evidence'),
  component: Outlet,
});
